import { CUSTOM_FILTERS } from "@/config/list";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
import { networkTypeConfig } from "@/config/networkType";
import { NetworkTypeBadge } from "@/components/badges/NetworkTypeBadge";
import { ListFilters } from "@/types/list";

type NetworkTypeFilterProps = {
	filter: ListFilters;
};

export const NetworkTypeFilter = ({ filter }: NetworkTypeFilterProps) => {
	const value = filter.getFilter(CUSTOM_FILTERS.networkType) as Dryp.NetworkType | undefined;

	const clearFilter = () => {
		filter.clearFilter(CUSTOM_FILTERS.networkType);
	};

	const onChange = (selected?: Dryp.NetworkType) => {
		if (selected === undefined) {
			clearFilter();
		} else {
			filter.setFilter(CUSTOM_FILTERS.networkType, selected);
		}
	};

	return (
		<div className="relative z-10">
			<div className="flex flex-col space-y-1">
				<span className="text-xs font-medium text-muted-foreground">Network Type</span>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<Button variant="outline" className="justify-start">
							{value ? (
								<NetworkTypeBadge type={value} showLabel />
							) : (
								<span className="font-semibold text-muted-foreground">All</span>
							)}
							<ChevronDown className="ml-2 h-4 w-4 opacity-50" />
						</Button>
					</DropdownMenuTrigger>
					<DropdownMenuContent align="start">
						<DropdownMenuItem
							onSelect={() => onChange(undefined)}
							className={!value ? "font-semibold bg-muted" : ""}
						>
							All
						</DropdownMenuItem>

						{Object.keys(networkTypeConfig).map(networkTypeValue => (
							<DropdownMenuItem
								key={networkTypeValue}
								onSelect={() => onChange(networkTypeValue as Dryp.NetworkType)}
								className={value === networkTypeValue ? "font-semibold bg-muted" : ""}
							>
								<NetworkTypeBadge type={networkTypeValue as Dryp.NetworkType} showLabel />
							</DropdownMenuItem>
						))}
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</div>
	);
};
